import type { EnrolledSession } from "../models/types";
import { OPENING_QUICK_RETURN_MS, STORAGE_KEYS } from "../config";

export function loadSession(): EnrolledSession | null {
  const raw = sessionStorage.getItem(STORAGE_KEYS.session);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as EnrolledSession;
  } catch {
    return null;
  }
}

export function saveSession(session: EnrolledSession): void {
  sessionStorage.setItem(STORAGE_KEYS.session, JSON.stringify(session));
}

export function clearSession(): void {
  sessionStorage.removeItem(STORAGE_KEYS.session);
}

export function isSessionExpired(session: EnrolledSession): boolean {
  const now = Math.floor(Date.now() / 1000);
  return session.expires_at <= now;
}

export function loadPendingAccessRequest(): string | null {
  return localStorage.getItem(STORAGE_KEYS.pendingAccess);
}

export function savePendingAccessRequest(id: string): void {
  localStorage.setItem(STORAGE_KEYS.pendingAccess, id);
}

export function clearPendingAccessRequest(): void {
  localStorage.removeItem(STORAGE_KEYS.pendingAccess);
}

export function hasSeenOpening(): boolean {
  return localStorage.getItem(STORAGE_KEYS.openingSeen) === "1";
}

export function markOpeningSeen(): void {
  localStorage.setItem(STORAGE_KEYS.openingSeen, "1");
  localStorage.setItem(STORAGE_KEYS.openingSeenAt, String(Date.now()));
}

export function shouldSkipOpening(): boolean {
  if (localStorage.getItem(STORAGE_KEYS.openingSeen) !== "1") return false;
  const at = Number(localStorage.getItem(STORAGE_KEYS.openingSeenAt) ?? "0");
  if (!at) return false;
  return Date.now() - at < OPENING_QUICK_RETURN_MS;
}

export function resetOpeningSeen(): void {
  localStorage.removeItem(STORAGE_KEYS.openingSeen);
  localStorage.removeItem(STORAGE_KEYS.openingSeenAt);
}

export function resetTabIntros(): void {
  localStorage.removeItem(STORAGE_KEYS.tabIntros);
}

export function hasSeenBirthdayPriming(): boolean {
  return localStorage.getItem(STORAGE_KEYS.birthdayPrimingSeen) === "1";
}

export function markBirthdayPrimingSeen(): void {
  localStorage.setItem(STORAGE_KEYS.birthdayPrimingSeen, "1");
}

export function hasSeenTabIntro(tab: string): boolean {
  const raw = localStorage.getItem(STORAGE_KEYS.tabIntros);
  if (!raw) return false;
  try {
    const seen = JSON.parse(raw) as string[];
    return seen.includes(tab);
  } catch {
    return false;
  }
}

export function markTabIntroSeen(tab: string): void {
  const raw = localStorage.getItem(STORAGE_KEYS.tabIntros);
  const seen = raw ? (JSON.parse(raw) as string[]) : [];
  if (!seen.includes(tab)) seen.push(tab);
  localStorage.setItem(STORAGE_KEYS.tabIntros, JSON.stringify(seen));
}

export function birthdayRemindersEnabled(): boolean {
  return localStorage.getItem(STORAGE_KEYS.birthdayReminders) !== "0";
}

export function setBirthdayRemindersEnabled(enabled: boolean): void {
  localStorage.setItem(STORAGE_KEYS.birthdayReminders, enabled ? "1" : "0");
}
